import "./RaikoCardInfoTypeTwo.scss"
import {
    RaikoButtonPrimary,
    RaikoChipSizeType,
    RaikoChipTypes,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoCustomSimpleChip,
    RaikoLabel,
    RaikoLabelType
} from "@moeindal/base-raiko-panel-components";


export default function RaikoCardInfoTypeTwo(
    {
        photo,
        alert,
        title = "",
        status = true,
        statusState,
        subTitle = "",
        onClick,
    }) {


    return (
        <div className={"raikoCardInfoTypeTwoLayout"} onClick={onClick}>
            <div className={"photoContainer"}>
                <img src={photo} alt={alert}/>
                {
                    status ? <div className={"chipContainer"}>
                        {
                            statusState === "AWAITING_FOR_REVIEW" ?
                                <RaikoCustomSimpleChip size={RaikoChipSizeType.small} title={"در حال بررسی"}
                                                       type={RaikoChipTypes.warningColorFul}/> :
                                statusState === "ACCEPTED" ?
                                    <RaikoCustomSimpleChip size={RaikoChipSizeType.small} title={"پذیرفته شده"}
                                                           type={RaikoChipTypes.successColorful}/> :
                                    <RaikoCustomSimpleChip size={RaikoChipSizeType.small} title={"رد شده"}
                                                           type={RaikoChipTypes.errorColorful}/>
                        }
                    </div> : <></>
                }

            </div>
            <div className={"descriptionLayoutCard"}>
                <div className={"descriptionContainer"}>
                    <RaikoLabel text={title} raikoLabelType={RaikoLabelType.TITLE}/>
                </div>
                <div className={"descriptionContainer"}>
                    <div className={"ic_calendar"}/>
                    <RaikoLabel text={subTitle} raikoLabelType={RaikoLabelType.SUBTITLE}/>
                </div>
            </div>
        </div>
    )

}